import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ButtonProps } from '@material-ui/core/Button/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import { t } from 'src/lib/language';
import { DIALOGS } from 'src/models/DialogModel';
import { openDialog } from 'src/redux/actions/dialogActions';

const DownloadSubscriptionButton = (props: ButtonProps) => {
  const dispatch = useAppDispatch();
  const { disabled } = props;

  const lang = useSelector((state: Store) => state.language.language);

  const handleOpen = () => {
    dispatch(openDialog({ dialog: DIALOGS.subscriptionDownload }));
  };

  return (
    <>
      <Tooltip
        title={t(lang, 'menus.download_subscriptions')}
        placement="top-start">
        <span>
          <ActionButton
            variant="outlined"
            category={MENU_BUTTON_CATEGORY.download}
            onClick={handleOpen}
            disabled={disabled}>
            <GetAppIcon />
          </ActionButton>
        </span>
      </Tooltip>
    </>
  );
};

export default DownloadSubscriptionButton;
